import { create } from "zustand";
import { persist } from "zustand/middleware";

export interface ShippingOption {
  id: string;
  label: string;
  etaBusinessDays: number;
  priceBRL: number;
  quoteId?: number;
}

interface ShippingOptionState {
  shippingOption: ShippingOption | null;
  setShippingOption: (option: ShippingOption) => void;
  clearShippingOption: () => void;
}

const useShippingOptionStore = create<ShippingOptionState>()(
  persist(
    (set) => ({
      shippingOption: null,
      setShippingOption: (option) => set({ shippingOption: option }),
      clearShippingOption: () => set({ shippingOption: null }),
    }),
    { name: "embarca-log.shipping_option" }
  )
);

export default useShippingOptionStore;
